import React, { useState } from "react";
import '../../sass/components/flexibleModules/_components.SolutionExchangeComponent.scss';
import { StaticImage } from "gatsby-plugin-image";

const SolutionExchangeComponent = ({ data }) => {

    const [checkPopup, setCheckPopup] = useState(false);
    const [checkPopupIndex, setCheckPopupIndex] = useState(false);
    const hideAlertCheck = (val, ind) => {
        setCheckPopup(val);
        setCheckPopupIndex(ind);
    }

    return (
        <div class="cp-solutionExchange" style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div class="cp-solutionExchange__inner l--flex" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                {data.solutionExchangeGridSections &&
                    <>
                        {data.solutionExchangeGridSections.map((exchange, index) => (
                            <button className="cp-solutionExchange__gridSection l--flex" key={index} onClick={() => hideAlertCheck(true, index)}>
                                {exchange.sectionSubTitle &&
                                    <h4>{exchange.sectionSubTitle}</h4>
                                }
                                {exchange.sectionTitle &&
                                    <h3>{exchange.sectionTitle}</h3>
                                }
                                {exchange.sectionLogo &&
                                    <img src={exchange.sectionLogo.sourceUrl} alt={exchange.sectionLogo.altText} />
                                }
                            </button>
                        ))}
                    </>
                }
            </div>
            {checkPopup &&
                <div className="cp-solutionExchange__modal">
                    <div className="cp-solutionExchange__modal-section">
                        {data.solutionExchangeGridSections.map((exchange, index) => (
                            <React.Fragment key={index}>
                                {checkPopupIndex === index &&
                                    <>
                                        {exchange.sectionLogo &&
                                            <img src={exchange.sectionLogo.sourceUrl} alt={exchange.sectionLogo.altText} />
                                        }
                                        {exchange.sectionTitle &&
                                            <h3>{exchange.sectionTitle}</h3>
                                        }
                                        <span>Overview</span>
                                        {exchange.sectionModalContent &&
                                            <div dangerouslySetInnerHTML={{ __html: exchange.sectionModalContent }} />
                                        }
                                    </>
                                }
                            </React.Fragment>
                        ))}
                        <button className="cp-solutionExchange__close" onClick={() => hideAlertCheck(false, 0)}>
                            <StaticImage src="../../images/cross-Icon.svg" alt=""></StaticImage>
                        </button>
                    </div>
                    <button className="cp-solutionExchange__closebg" onClick={() => hideAlertCheck(false, 0)}></button>
                </div>
            }
        </div>
    );
}

export default SolutionExchangeComponent;